<template>
  <div class="vx-row match-height">
    <div class="vx-col w-full">
      <vx-card>
        <vs-tabs vs-alignment="fixed" alignment="fixed">
          <div>
            <vs-tab
              :label="$t('AvailableBaseSalePrices')"
              class="mt-6"
              v-if="
                $tabHasPermission(
                  'GetAllBaseSalePricesByContract|GetItemsOfBaseSalePrice|CreateBaseSalePrice|AssignBaseSalePriceItems'
                )
              "
            >
              <available-base-sale-prices></available-base-sale-prices>
            </vs-tab>
          </div>
          <div>
            <vs-tab
              :label="$t('BaseSalePriceHistory')"
              class="mt-6"
              v-if="
                $tabHasPermission('GetAllHistoriesOfBaseSalePriceWithPageInfo')
              "
            >
              <base-sale-price-history></base-sale-price-history>
            </vs-tab>
          </div>
        </vs-tabs>
      </vx-card>
    </div>
  </div>
</template>
<script>
import AvailableBaseSalePrices from "./AvailableBaseSalePrices/Index.vue";
import BaseSalePriceHistory from "./BaseSalePriceHistory/Index.vue";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";

export default {
  name: "",
  components: {
    AvailableBaseSalePrices,
    BaseSalePriceHistory,
  },
};
</script>
